export default function CtaSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            {/* Image */}
            <div className="relative w-full max-w-2xl mx-auto rounded-2xl overflow-hidden mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20a%20modern%20creative%20workspace%20with%20a%20tablet%20showing%20colorful%20data%20charts%20a%20steaming%20ceramic%20coffee%20cup%20fresh%20croissant%20on%20a%20small%20plate%20fashion%20catalog%20pages%20fanned%20out%20and%20a%20pair%20of%20trendy%20sunglasses%20all%20arranged%20on%20a%20warm%20cork%20board%20desk%20surface%2C%20morning%20sunlight%20casting%20soft%20diagonal%20rays%2C%20lush%20green%20monstera%20leaf%20peeking%20in%20from%20the%20corner%2C%20productive%20morning%20routine%20aesthetic%20with%20organized%20chaos%20and%20warm%20inviting%20tones&width=1200&height=600&seq=cta-v2-css-01&orientation=landscape"
                alt="CSSBuy Spreadsheet - Start exploring now"
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Text */}
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 mb-4 leading-tight">
              Ready to Explore the
              <br />
              <span className="italic text-foreground-700 font-normal">Ultimate CSSBuy Spreadsheet?</span>
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto mb-8">
              Thousands of verified finds are waiting. Jump into the most comprehensive CSSBuy spreadsheet database and start discovering deals today.
            </p>

            {/* CTA Button */}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold text-background-50 bg-foreground-950 hover:bg-foreground-800 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              Explore CSSBuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}